import { FC } from 'react';
import { Button, IconRefresh } from '@screentone/core';

interface ResetDefaultProps {
  handleResetToDefault: () => void;
  isReadOnly?: boolean;
}

export const ResetDefault: FC<ResetDefaultProps> = ({ handleResetToDefault, isReadOnly = false }) => (
  <Button
    tertiary
    icon={IconRefresh}
    onClick={handleResetToDefault}
    disabled={isReadOnly}
    data-testid="settings-reset-default-button"
  >
    Reset to default
  </Button>
);
